export function formatAuthors(names: string[]) {
  const n = names.filter(Boolean)

  if (n.length === 0) {
    return 'Ukjente forfattere'
  }

  if (n.length === 1) {
    return n[0]
  }

  if (n.length === 2) {
    return `${n[0]} og ${n[1]}`
  }

  return `${n.slice(0, -1).join(', ')} og ${n[n.length - 1]}`
}
